import React from 'react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Handshake, Shield, Heart } from 'lucide-react';
import mockData from '../data/mock';

const AboutSection = () => {
  const { about } = mockData;

  const iconMap = {
    Handshake,
    Shield,
    Heart
  };

  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <Badge className="bg-slate-100 text-slate-700 border-slate-200 mb-4">
            Tentang Kami
          </Badge>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            {about.title}
          </h2>
          <p className="text-2xl md:text-3xl font-bold text-transparent bg-gradient-to-r from-[#2D9CDB] to-slate-900 bg-clip-text mb-8">
            {about.vision}
          </p>
          <p className="text-lg text-slate-600 max-w-4xl mx-auto leading-relaxed">
            {about.description}
          </p>
        </div>

        {/* Values */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
          {about.values.map((value, index) => {
            const IconComponent = iconMap[value.icon];
            return (
              <Card key={index} className="border-0 shadow-lg hover:shadow-xl transition-all duration-300 group hover:scale-105">
                <CardContent className="p-8 text-center">
                  <div className="w-16 h-16 bg-gradient-to-br from-[#2D9CDB] to-blue-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                    <IconComponent className="h-8 w-8 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 mb-4">{value.title}</h3>
                  <p className="text-slate-600">{value.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Mission Statement */}
        <div className="bg-gradient-to-r from-slate-50 to-blue-50/50 rounded-3xl p-8 md:p-12 text-center">
          <div className="max-w-4xl mx-auto">
            <h3 className="text-2xl md:text-3xl font-bold text-slate-900 mb-6">
              Misi Kami
            </h3>
            <p className="text-lg text-slate-700 mb-8 leading-relaxed">
              Kami berkomitmen untuk menciptakan ekosistem digital yang memungkinkan semua pihak dalam industri pariwisata dan perdagangan mendapatkan keuntungan yang adil. Melalui teknologi yang inovatif dan sistem yang transparan, kami membangun jembatan kepercayaan antara driver, merchant, dan wisatawan.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-12 h-12 bg-gradient-to-br from-[#2D9CDB] to-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                  <span className="text-white font-bold text-lg">1</span>
                </div>
                <h4 className="font-semibold text-slate-900 mb-2">Transparansi</h4>
                <p className="text-slate-600 text-sm">Sistem yang jelas dan mudah dipahami untuk semua pihak</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 bg-gradient-to-br from-[#2D9CDB] to-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                  <span className="text-white font-bold text-lg">2</span>
                </div>
                <h4 className="font-semibold text-slate-900 mb-2">Inovasi</h4>
                <p className="text-slate-600 text-sm">Teknologi terdepan untuk kemudahan dan efisiensi</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 bg-gradient-to-br from-[#2D9CDB] to-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                  <span className="text-white font-bold text-lg">3</span>
                </div>
                <h4 className="font-semibold text-slate-900 mb-2">Keberlanjutan</h4>
                <p className="text-slate-600 text-sm">Membangun kemitraan jangka panjang yang saling menguntungkan</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;